// extracted by mini-css-extract-plugin
module.exports = {"clientStatusTag":"clientStatusTag--MIbID"};